import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-hot-toast'

import {
  SEARCH_ICON,
  ERROR_ICON,
  PINFLAG_PRIMARY_COLOR
} from '../../constants/urls'
import { DataContext } from '../../context/DataContext'

import ReSendModal from '../ReSendModal/ReSendModal'
import SubmitButton from '../shared/SubmitButton'
import Input from '../shared/Input'
import TextBalloon from '../shared/TextBalloon'
import Footer from '../shared/Footer'

import TitleContainer from './TitleContainer'

const ValidationContainer: React.FC = () => {
  const {
    companyData,
    openPopUp
  } = useContext(DataContext)
  const history = useHistory()

  const [searchBarInput, setSearchBarInput] = useState('')
  const [isLostNumberModalOpen, setIsLostNumberModalOpen] = useState(false)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    if (openPopUp) {
      toast.error('Orden no encontrada. Ingrese su orden nuevamente.', {
        style: {
          display: 'flex',
          backgroundColor: '#FF8080',
          color: 'white',
          fontFamily: 'Onest'
        }
      })
    }
  }, [openPopUp])

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      let orderCode = searchBarInput
      orderCode = orderCode.replace('#', '')
      if (orderCode.trim() === '') {
        toast.error('Inserte un número de orden.', {
          style: {
            backgroundColor: '#FF8080',
            color: 'white',
            fontFamily: 'Onest'
          }
        })
      } else {
        history.push(`tracking/${orderCode.toUpperCase()}`)
        setSearchBarInput('')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchBarInput(e.target.value)
  }

  const handleOpenLostNumberModal = () => {
    setIsLostNumberModalOpen(true)
  }

  const primaryColor = companyData?.primaryColor || PINFLAG_PRIMARY_COLOR

  return (
    <div
      className="flex flex-col md:justify-between items-center bg-white rounded-2xl min-h-full portrait:m-4 portrait:border portrait:border-gray-200"
      style={{ '--primary-color': primaryColor } as React.CSSProperties}
    >
      <div className="landscape:mt-10 mt-2 w-full landscape:gap-14 gap-6 flex flex-col items-center">
        <TitleContainer />

        <form
          className="justify-center items-start md:flex-col w-full"
          onSubmit={handleSubmit}
        >
          <div className='flex justify-center'>
            <div className="flex flex-col gap-2 portrait:w-full landscape:w-96 mx-8">
              <div className='h-14 portrait:mb-2'>
                <Input
                  placeholder='Número de orden'
                  searchBarInput={searchBarInput}
                  handleChange={handleChange}
                  leftComponent={
                    <img
                      className="w-5 md:w-7 mx-2"
                      alt="icon-input"
                      src={SEARCH_ICON}
                    />
                  }
                  rightComponent={
                    searchBarInput.length === 0 && (
                      <div className="relative w-6 h-6 md:h-8 flex-shrink-0 mr-2">
                        <img
                          onMouseEnter={() => setHovered(true)}
                          onMouseLeave={() => setHovered(false)}
                          src={ERROR_ICON}
                          alt="error-icon"
                          className="w-6 h-6 md:h-8 flex-shrink-0"
                        />

                        {hovered && (
                          <TextBalloon
                            className="absolute -top-12 -right-[163px]"
                            ballonClassName="pt-2 text-center"
                          >
                            <p className="text-sm whitespace-nowrap text-white w-auto">Encuentra el número en tu correo de confirmación</p>
                          </TextBalloon>
                        )}
                      </div>
                    )
                  }
                />
              </div>

              <div className='h-12'>
                <SubmitButton
                  text="Rastrear"
                  companyColor={primaryColor}
                  dark
                />
              </div>

              <button
                type="button"
                className="md:text-[15px] text-[10px] mt-2 mb-4"
                onClick={() => handleOpenLostNumberModal()}
              >
                <p className="md:text-[15px] portrait:text-base text-gray-700 portrait:mb-4">¿No recibiste el&nbsp;
                <span className='font-semibold underline' style={{ color: primaryColor }}>número de orden</span>?</p>
              </button>

            </div>
            <div>
              <p className="hidden bg-[#f0394d] mt-[2vh] p-[2vh] justify-center font-bold rounded-[10px]">
                Número de orden no encontrado. Intentelo nuevamente.
              </p>
            </div>
          </div>
        </form>
      </div>

      <ReSendModal
        handleClose={() => setIsLostNumberModalOpen(false)}
        isOpen={isLostNumberModalOpen}
      />

      <div className="landscape:block hidden mb-10 mt-6">
        <Footer />
      </div>
    </div>
  )
}

export default ValidationContainer
